import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../store/AriStore'
import { closeAlert } from '../reducer/alert'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export default function AlertDialog() {
  const dispatch = useDispatch()
  const { open, message, onClose } = useSelector((state: RootState) => state.alert)

  const handleClose = () => {
    dispatch(closeAlert())
    if (onClose) {
      try { onClose() } catch { /* no-op */ }
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>알림</DialogTitle>
      <DialogContent>
        <Typography variant="body1" display="inline-block" sx={{ mt: 0.5, whiteSpace: 'pre-line' }}>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>확인</Button>
      </DialogActions>
    </Dialog>
  )
}


